import EventLogTypeDTO from '@src/adapters/dto/eventLog/EventLogTypeDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  types: EventLogTypeDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/eventlog/types/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetEventLogTypesLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetEventLogTypesLazy;
